import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { withTheme } from '@energybox/react-ui-library/dist/utils';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { unregister } from './registerServiceWorker';
import App from './containers/App';
import { initApp, initAppWithToken } from './actions/app';
import './styles';
import '@energybox/react-ui-library/dist/root.css';

export const FLAG_HIDE_ON_PRODUCTION =
  process.env.REACT_APP_SERVICE_ENV !== 'production';

// Enable this line to persist the redux-store in localStorage
// store.subscribe(() => saveState(store.getState()));

try {
  const fragment = window.location.hash.substr(1);
  const params = new URLSearchParams(fragment);
  if (params.has('accessToken')) {
    const accessToken = params.get('accessToken');
    store.dispatch(initAppWithToken({ accessToken }));
  } else {
    store.dispatch(initApp());
  }
} catch (err) {
  // access to window is blocked?
}

const AppWithTheme = withTheme(App);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DndProvider backend={HTML5Backend}>
          <AppWithTheme />
        </DndProvider>
      </MuiPickersUtilsProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

unregister();
